import { useCallback, useContext, useEffect, useState } from 'react';
import { ChatConversation } from '../../../../../../../common';
import { getProviderCards } from '../../../../../../../utils/provider';
import { ConfigurationContext } from '../../../../../../../context/configurationContext';
import ProviderCards from '../../../Base/providerCards';

import * as api from '../../../../../../../api';
import Filters from './Filters';
import { type ProviderFilters } from './Filters/common';

interface Props {
  message: ChatConversation;
}

const ProviderPanel: React.FC<Props> = ({ message }) => {
  const configurationContext = useContext(ConfigurationContext);
  const [staticFilters, setStaticFilters] = useState<
    api.Assistant.ProviderFilters | undefined
  >();
  const [activeFilters, setActiveFilters] = useState<ProviderFilters>({
    dynamicActiveFilters: [],
  });
  const { total } = getProviderCards(message);

  const fetchFilters = useCallback(async () => {
    if (!configurationContext?.id) return;
    try {
      const filters = await api.client.Assistant.getSearchProviderFilters(
        configurationContext.id,
      );
      setStaticFilters(filters);
    } catch (err) {
      console.error(err);
    }
  }, [configurationContext?.id]);

  useEffect(() => {
    fetchFilters();
  }, [fetchFilters]);

  return (
    <div>
      <h4>
        {total} provider{total > 1 ? 's' : ''}
      </h4>
      <Filters
        activeFilters={activeFilters}
        onChange={setActiveFilters}
        dynamicActiveFilters={activeFilters.dynamicActiveFilters ?? []}
        availablePractices={staticFilters?.supportedPractices ?? []}
        availableLanguages={staticFilters?.supportedLanguages ?? []}
      />
      <ProviderCards message={message} />
    </div>
  );
};

export default ProviderPanel;
